import { render, staticRenderFns } from "./smartpagetwo2.vue?vue&type=template&id=cd9c8006&scoped=true"
import script from "./smartpagetwo2.vue?vue&type=script&lang=js"
export * from "./smartpagetwo2.vue?vue&type=script&lang=js"
import style0 from "./smartpagetwo2.vue?vue&type=style&index=0&id=cd9c8006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9c8006",
  null
  
)

export default component.exports